import PropTypes from 'prop-types'
import React from 'react'
import Moment from 'react-moment'
import 'moment-timezone'

// Utils
import getLocalDateFromUTC from 'app/views/utils/getLocalDateFromUTC'


const propTypes = {
  codeSubmissions: PropTypes.arrayOf(PropTypes.object).isRequired,
}

const PatchHistory = ({ codeSubmissions, hasTest }) => (
  <div>
    {(codeSubmissions.length === 0) ? (
      <p>You have not submitted any code patches.</p>
    ) : (
      <table className="uk-table uk-table-small uk-table-striped">
        <thead>
          <tr>
            {(hasTest) && <th>Status</th>}
            {(hasTest) && <th>Reason</th>}
            <th>Submitted</th>
            <th />
          </tr>
        </thead>
        {codeSubmissions.map((code) => {
          const localDate = getLocalDateFromUTC(code.submitted_at)
          let testStatusLabel = <span className="uk-label" style={{ backgroundColor: '#DDDDDD' }}>Unknown</span>
          if (code.test.passed === true) {
            testStatusLabel = <span className="uk-label uk-label-success">Passed</span>
          } else if (code.test.passed === false) {
            testStatusLabel = <span className="uk-label uk-label-danger">Failed</span>
          }
          return (
            <tbody key={code.id} data-test-id="patch-history-record">
              <tr>
                {(hasTest) && (
                  <td>{testStatusLabel}</td>
                )}

                {(hasTest) && (
                <td>
                  {code.test.error_message}
                  {(code.test.url) && (
                    <div className="uk-text-small">
                      <a
                        href={code.test.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        alt="help link"
                      >
                        {code.test.url}
                      </a>
                    </div>
                  )}
                </td>
                )}

                <td>
                  <Moment fromNow>{localDate}</Moment>
                </td>

                <td className="uk-text-right">
                  <button
                    data-test-id="patch-history-see-code-btn"
                    href={`toggle-animation-${code.id}`}
                    className="uk-button uk-button-default uk-button-small tm-button-default"
                    type="button"
                    data-uk-toggle={`target: #toggle-animation-${code.id}; animation: uk-animation-fade`}
                  >
                    See Code
                  </button>
                </td>
              </tr>
              <tr id={`toggle-animation-${code.id}`} hidden>
                <td colSpan="4" style={{ padding: 0 }}>
                  <pre style={{ maxWidth: 873 }} data-test-id="patch-history-code-container">
                    {code.code}
                  </pre>
                </td>
              </tr>
            </tbody>
          )
        })}
      </table>
    )}
  </div>
)

PatchHistory.propTypes = propTypes


export default PatchHistory
